import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ConfirmDialogComponent, ToastComponent } from '@platform/uikit';
import { filter } from 'rxjs';
import type { PlatformConfig } from '../../../libs/platform-config/src';
import { PLATFORM_CONFIG } from '../../../libs/platform-config/src';
import { SplashScreenComponent } from '../modules/shared/components/splash-screen/splash-screen.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmDialogComponent, RouterLink, TranslocoPipe, ToastComponent, SplashScreenComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ICU');
  protected readonly config = inject<PlatformConfig>(PLATFORM_CONFIG);
  selectedRoute = signal<string | null>('user');
  showBottomBar = signal(false);
  showSplash = signal(true);
  router = inject(Router);
  route = inject(ActivatedRoute);
  // Order matters: more specific routes first so '/user/profile' resolves to 'profile' rather than 'user'.
  routeConfigs = [
    'profile',
    'nurses',
    'doctors',
    'icu',
    'user',
  ];
  navItems = [
    { key: 'user', icon: 'fa-house', route: ['/'], labelKey: 'user.dashboard.patients' },
    { key: 'doctors', icon: 'fa-user-large', route: ['/doctors'], labelKey: 'user.dashboard.doctors' },
    { key: 'nurses', icon: 'fa-clipboard', route: ['/nurses'], labelKey: 'user.dashboard.nurses' },
    { key: 'icu', icon: 'fa-bed', route: ['/icu'], labelKey: 'user.dashboard.icu' },
    { key: 'profile', icon: 'fa-user-circle', route: ['/user/profile'], labelKey: 'user.dashboard.profile' },
  ];
  constructor() {
    this.init();
  }

  private init() {
    this.updateRoute(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateRoute(event.urlAfterRedirects);
    });
  }

  private updateRoute(url: string) {
    this.showBottomBar.set(!url.includes('auth'));
    const config = this.routeConfigs.find(cfg => url.includes(cfg));
    if (config) {
      this.selectedRoute.set(config);
    } else {
      this.selectedRoute.set(null);
    }
  }

  onSplashDone() {
    this.showSplash.set(false);
  }
}




